<div class="multiple-comment" fxLayout="column" >
  <div fxLayout="row" fxLayoutAlign="space-between center">
    <h4>{{ 'COMMENTS' | translate }}</h4>
    <button mat-icon-button [matDialogClose]="">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div class="comment" fxLayout="row" fxLayoutAlign="space-between center">
    <mat-form-field>
      <mat-label>{{ 'COMMENT' | translate }}</mat-label>
      <textarea #area matInput [formControl]="commentText"></textarea>
    </mat-form-field>

    <button
      [disabled]="!commentText.value || commentText.value === initialValue"
      mat-icon-button
      matTooltip="Saugoti"
      (click)="updateComment()"
    >
      <mat-icon>send</mat-icon>
    </button>
  </div>

<!--  <div *ngIf="comments" class="comments-list" fxLayout="column" fxLayoutAlign="center start">-->
<!--    <div-->
<!--      *ngFor="let item of comments; let isFirst = first"-->
<!--      fxLayout-->
<!--      fxLayoutAlign="start center"-->
<!--      [class.highlighted]="item?.id === selectedComment?.id"-->
<!--      [class.first]="isFirst"-->
<!--      (click)="selectComment(item)"-->
<!--    ><span>{{ item?.comment }}</span></div>-->
<!--  </div>-->

<!--  <button-->
<!--    style="margin: 8px 0 20px 0; background-color: rgb(255, 193, 7)"-->
<!--    mat-button-->
<!--    [disabled]="isCreating || isLoading"-->
<!--    (click)="addComment()"-->
<!--  ><mat-icon>add</mat-icon>{{ 'NEW_COMMENT' | translate }}</button>-->
</div>
